import { Component } from "@angular/core";

@Component({
    selector: 'app-image-backgroud',
    templateUrl: './image-backgroud.component.html',
})
export class ImageBackgroudComponent {}